export const IconImage = {
  class:
    'https://res.cloudinary.com/intercambiodireto-com/f_auto,c_limit,w_128,q_auto/Others/Icons/icon-class-2x-64x64_udotmm',
  talk: 'https://res.cloudinary.com/intercambiodireto-com/f_auto,c_limit,w_128,q_auto/Others/Icons/icon-talk-2x-64x64_k3krgd',
  abroad:
    'https://res.cloudinary.com/intercambiodireto-com/f_auto,c_limit,w_128,q_auto/Others/Icons/pass-2x-64x64_jp5ozc',
};

export const aboutFluencypass = [
  {
    icon: 'class',
    text: 'Acesso ilimitado 24/7 a cursos do básico ao avançado, alinhados com o CEFR.',
    title: 'Teoria',
  },
  {
    icon: 'talk',
    text: 'Junte-se e pratique em diversas salas de conversação diárias.',
    title: 'Inglês para tecnologia',
  },
  {
    icon: 'talk',
    text: 'Aulas particulares ajustáveis à sua agenda com feedback sob medida.',
    title: 'Prática',
  },
  {
    icon: 'abroad',
    text: 'Experimente o intercâmbio cultural em mais de 40 destinos globais.',
    title: 'Imersão',
  },
];

export const techJourneyContent = {
  title:
    'Em um mercado global cada vez mais competitivo, dominar o inglês não é mais um diferencial, é uma necessidade…',
  paragraphs: [
    'A Fluencypass é capaz de entregar soluções como: Escola online, aulas de conversação em grupo, aulas particulares para pessoas e empresas em uma jornada de aprendizado integrado',
    'Além de oferecer intercâmbio conectando estudantes diretamente com escolas em mais de 8 países, sem cobrar taxa de agência e oferecendo suporte e assessoria especializada.',
  ],
  list: aboutFluencypass,
};

export const whoIsContent = {
  title: 'Para quem é o Tech English?',
  content: [
    {
      icon: 'clock',
      title: 'Quer aprender rápido',
      text: 'O curso pode ser consumido de forma intensiva, proporcionando resultados rápidos.',
    },
    {
      icon: 'money',
      title: 'Quer ser mais valorizado',
      text: 'Um profissional que domina um idioma global se torna uma peça chave para qualquer empresa.',
    },
    {
      icon: 'growth',
      title: 'Quer receber mais oportunidades',
      text: 'Com o inglês você quebra barreiras e um leque de oportunidades é aberto.',
    },
    {
      icon: 'group',
      title: 'Quer praticar todos os dias',
      text: 'Com o acesso ilimitado à aulas de conversação em grupo, você poderá encaixar o inglês na sua rotina.',
    },
  ],
};

export const warrantyContent = {
  title: 'Dupla garantia',
  subtitle:
    'A Fluencypass tem tudo o que você precisa para falar inglês de uma vez por todas.',
  content: [
    {
      imageUrl: 'warranty',
      text: 'Você tem 7 dias à partir do momento da compra para decidir se é para você ou não, faça a aula de conversação em grupo, e se decidir que não é para você, você pode pedir reembolso integral.',
    },
    {
      imageUrl: 'refund',
      text: 'Se você seguir nosso método (1 lição por dia e 2 conversação em grupo por semana) e não falar inglês em 12 meses, nós devolvemos seu dinheiro.',
    },
  ],
};

export const techEnglishOverview = {
  outsideBackground: '#0288d1',
  innerBackground: 'rgba(0, 0, 0, 0.50)',
  textColor: 'background.paper',
  title: 'Tech English',
  subtitle: 'A sua ponte para um futuro de oportunidades',
  imageUrl:
    'https://res.cloudinary.com/intercambiodireto-com/image/upload/v1709323443/OnlineSchool/Verticals/EnglishForTech/Ativo_14_4x_1_1_tp5dhl.png',
  paragraphs: [
    'Ao assinar o “nome do curso”, você terá acesso a uma escola online, acesso ilimitado à aulas de conversação em grupo e aulas particulares, além de receber um certificado internacional a cada nível avançado e acesso a uma comunidade com alunos e profissionais de tecnologia engajados, tudo em um só lugar!',
    'Desde o início da sua jornada, você poderá acessar módulos focados no contexto da sua área e se tornar um profissional cada vez mais valorizado!',
  ],
};

export const newEnglishOverview = {
  outsideBackground: '#01579B',
  textColor: 'background.paper',
  title:
    'Com o curso de Inglês para Tecnologia da Fluencypass, você vai muito além do básico...',
  courses: [
    {
      title: 'Conversação em Grupo Ilimitada',
      description: 'Foco em termos técnicos e situações reais do dia a dia.',
      imageUrl: 'https://placehold.co/354x250',
    },
    {
      title: 'Aulas Particulares Personalizadas',
      description: 'Aulas com temas específicos de tecnologia.',
      imageUrl: 'https://placehold.co/354x250',
    },
    {
      title: 'Comunidade para Networking',
      description:
        'Acesso exclusivo a uma comunidade de profissionais de tecnologia.',
      imageUrl: 'https://placehold.co/354x250',
    },
    {
      title: 'Curso de Inglês para Negócios',
      description: 'Como bônus, um curso para alavancar sua carreira.',
      imageUrl: 'https://placehold.co/354x250',
    },
  ],
};

export const learnTrackContent = {
  backgroundColor: '#212121',
  isPrimarySwiper: false,
  textColor: 'background.paper',
  title: 'Veja os conteúdos que você vai aprender no curso',
  content: [
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
    {
      imageUrl: '/OnlineSchool/Class/Courses/business-english_l7jvmv',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vehicula ac nisl quis commodo.',
      courseTitle: 'Lorem Ipsum',
    },
  ],
};
